'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  // $urlRouterProvider.when("/", "/devicecert/list");
  $urlRouterProvider.when("/devicecert", "/devicecert/list");
  $stateProvider
    .state('devicecert', {
      url: '/devicecert?page',
      template: require('./devicecert.html'),
      authenticate: true
    })
    .state('devicecert.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'DeviceCertListController',
      controllerAs: 'devicecertListCtrl'
    })
    .state('devicecert.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'DeviceCertEditController',
      controllerAs: 'devicecertEditCtrl'
    })
    .state('devicecert.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'DeviceCertAddController',
      controllerAs: 'devicecertAddCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/devicecert/devicecert.routes.js